/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Importing_Event_GroupsInputs */

const en_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing Event Groups...`)
};

const fr_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des groupes d’événements...`)
};

const de_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen werden importiert...`)
};

const it_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione di gruppi di eventi...`)
};

const ru_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт групп событий...`)
};

const es_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando grupos de eventos...`)
};

const zh_cn2_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入事件组...`)
};

const ja_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント グループをインポートしています...`)
};

const hi_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप आयात किए जा रहे हैं...`)
};

const pt_pt2_automatic_save_importing_event_groups = /** @type {(inputs: Automatic_Save_Importing_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando grupos de eventos...`)
};

/**
* | output |
* | --- |
* | "Importing Event Groups..." |
*
* @param {Automatic_Save_Importing_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_importing_event_groups = /** @type {((inputs?: Automatic_Save_Importing_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Importing_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_importing_event_groups(inputs)
	if (locale === "de") return de_automatic_save_importing_event_groups(inputs)
	if (locale === "it") return it_automatic_save_importing_event_groups(inputs)
	if (locale === "ru") return ru_automatic_save_importing_event_groups(inputs)
	if (locale === "es") return es_automatic_save_importing_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_importing_event_groups(inputs)
	if (locale === "ja") return ja_automatic_save_importing_event_groups(inputs)
	if (locale === "hi") return hi_automatic_save_importing_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_importing_event_groups(inputs)
	return en_automatic_save_importing_event_groups(inputs)
});